import React, {Fragment, useEffect, useRef, useState} from 'react';
import {
    FormControl,
    FormLabel,
    MenuItem,
    Select,
} from '@mui/material';
import {t} from 'i18next';
import makeStyles from '@mui/styles/makeStyles';
import moment from 'moment';
import {useSelector} from 'react-redux';
import Formatter from '../../../util/formatter';
import {user} from '../../../store/reducers/user';
import Notes from '../../../util/notes'
import Grid from '@mui/material/Grid';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import Divider from '@mui/material/Divider';
import AgyleDatePicker from '../../../components/ui/fields/agyleDatePicker';
import AgyleButton from '../../../components/ui/buttons/agyleButton';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: 10,
        width: '100%',
    },
    divider: {
        width: '100%',
        alignItems: 'center',
        padding: "10px",
        marginBottom: '10px',
    },

    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    mandatory: {
        fontWeight: 'bold',
        color: '#e06666',
    },

    clearButton:{
        border: '1px solid #2180f7',
        height: '25px',
        placeSelf: "center",
    },

    label1:{
        fontWeight: 'bold',
    },
    label2:{
        fontSize: "10px",
        textIndent: '10px',
    },
    tableHeader:{
        textIndent: '10px',
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    margin:{
        marginBottom: '2px',
    },
    leftCenter:{
        display: 'flex',
        alignItems: 'center',
    },
    leftCenter2:{
        textAlign: 'left',
        width: '100%',
    },
    leftCenter3:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',

    },
    infoButton: {
        position: "absolute",
        top: "0",
        marginLeft: "10px",
        transform: "translateY(-100%)",
        border: "1px solid black",
        padding: "10px",
        backgroundColor: theme.palette.background.default,
        opacity: 1,
        borderRadius: "8px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        zIndex: 9999,
        whiteSpace: "pre-line",
        display: "flex",
        width: "max-content",
        maxWidth: "500px",
    },

    buttonsContainer:{
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
        width: "100%",
        padding: "10px",
    },

}));

const activityItems = [
    {
        id: "vocalisation1",
        field: "vocalisation",
        label: "1. Vocalisation",
        label2: "Eg Whimpering, groaning, crying",
    },
    {
        id: "facialExpression1",
        field: "facialExpression",
        label: "2. Facial Expression",
        label2: "Eg looking tense, frowning, grimacing, looking frightened",
    },
    {
        id: "changeInBody1",
        field: "changeInBody",
        label: "3. Change in body language",
        label2: "Eg Fidgeting, rocking, guarding part of body, withdrawn",
    },
    {
        id: "behavioural1",
        field: "behavioural",
        label: "4. Behavioural change",
        label2: "Increased confusion, refusing to eat, alteration in usual patterns",
    },
    {
        id: "physiological1",
        field: "physiological",
        label: "5. Physiological change",
        label2: "Eg Temperature, pulse or blood pressure outside normal limits, perspiring, flushing or pallor",
    },
    {
        id: "physical1",
        field: "physical",
        label: "6. Physical changes",
        label2: "Eg Skin tears, pressure areas, arthritis, contractures, previous injuries",
    },

]

const AbbeyPainScaleForm = (props) => {
    const classes = useStyles();
    const userObject = useSelector(user);
    const tester = Formatter.formatUserFullName(userObject);
    const [typeOfPainSelect, setTypeOfPainSelect] = useState('typeOfPain');

    const [abbeyForm, setAbbeyForm] = useState({
        unitNo: "",
        dob: props.patient?.patient?.dob ? moment(props.patient.patient.dob).format("DD/MM/YYYY") : "",
        familyName: props.patient?.patient?.familyName ? props.patient?.patient?.familyName : "",
        firstName: props.patient?.patient?.firstName ? props.patient.patient.firstName: "",

        dateAndTime1: null,
        vocalisation1: null,
        facialExpression1: null,
        changeInBody1: null,
        behavioural1: null,
        physiological1: null,
        physical1: null,

        total1: null,
        initials1: props.patient?.currentClinician,

        typeOfPain: "",
    })

    useEffect(() => {
        if (props.onSubmitFunction) {
            props.onSubmitFunction(handleSaveForm);
        }
        if (props.onDisableSubmit) {
            props.onDisableSubmit(isSubmitDisabled() || props.disableSave);
        }
    }, [abbeyForm, userObject, props.disableSave]);

    function InfoButton({ children }) {
        const [showInfo, setShowInfo] = useState(false);
        const infoRef = useRef(null);
        const [position, setPosition] = useState({ left: "100%", transform: "translateY(-100%)" });
        const classes = useStyles(); // Musimy to zadeklarować tutaj

        useEffect(() => {
            if (showInfo && infoRef.current) {
                const rect = infoRef.current.getBoundingClientRect();
                if (rect.right > window.innerWidth) {
                    setPosition({ left: "auto", right: "100%", marginRight: "10px" });
                } else {
                    setPosition({ left: "100%", transform: "translateY(-100%)" });
                }
            }
        }, [showInfo]);

        return (
            <div style={{ position: "relative", display: "inline-block" }}
                 onMouseEnter={() => setShowInfo(true)}
                 onMouseLeave={() => setShowInfo(false)}
            >
                <AgyleButton>
                    ?
                </AgyleButton>
                {showInfo && (
                    <div ref={infoRef} className={classes.infoButton} style={position}>
                        {children}
                    </div>
                )}
            </div>
        );
    }

    const handleChangeTextField = (event) => {
        const {name, value} = event.target;
        setAbbeyForm(pr => ({
            ...pr,
            [name]: value,
        }));
    };

    const isSubmitDisabled = () => {

    };

    const handleChangeTypeOfPainSelect = (event) => {
        setTypeOfPainSelect(event.target.value);
    };

    const handleSaveForm = () => {
        const objectToSave = {
            ...abbeyForm,
            timeStamp: moment().toISOString(),
            by: tester,
        }
      let dataArray = [{
          name: "studies.abbeyPainScoreForm",
          value: objectToSave,
          noteType: "studies.abbeyPainScoreForm",
          noteToAdd: Notes.getAbbeyPainScoreNote(objectToSave),
      }]

        props.onChange(dataArray);
    };

    useEffect(() => {

            setAbbeyForm(pr => ({
                ...pr,
                total1: Number(abbeyForm.vocalisation1) + Number(abbeyForm.facialExpression1) + Number(abbeyForm.changeInBody1) + Number(abbeyForm.behavioural1) + Number(abbeyForm.physiological1) + Number(abbeyForm.physical1),
            }))

    },[abbeyForm.vocalisation1, abbeyForm.facialExpression1, abbeyForm.changeInBody1, abbeyForm.behavioural1, abbeyForm.physiological1, abbeyForm.physical1])

    const renderActivityItems = () => {
        return activityItems.map(({id, field, label, label2})=> {
            return (
                <Fragment key={id}>
                    <>
                        {id === "total1" && (
                            <Divider className={classes.divider}/>
                        )}

                        <Grid item xs={3}>
                            <div className={classes.label1}>{t(label)}</div>
                        </Grid>
                        <Grid item xs={1}>
                            {label2 &&
                                <InfoButton> {t(label2)} </InfoButton>
                            }
                        </Grid>
                        <Grid item xs={1.5}/>
                        <Grid item xs={4} className={classes.buttonsContainer}>
                            <AgyleButton
                                onClick={
                                () => {
                                    setAbbeyForm(pr => ({
                                        ...pr,
                                        [`${field}1`]: "0",
                                    }))
                                }
                            }
                                variant="outlined"
                            >
                                {t('None')}
                            </AgyleButton>
                            <AgyleButton
                                onClick={
                                    () => {
                                        setAbbeyForm(pr => ({
                                            ...pr,
                                            [`${field}1`]: "1",
                                        }))
                                    }
                                }
                                variant="outlined"
                            >
                                {t('Mild')}
                            </AgyleButton>
                            <AgyleButton
                                onClick={
                                    () => {
                                        setAbbeyForm(pr => ({
                                            ...pr,
                                            [`${field}1`]: "2",
                                        }))
                                    }
                                }
                                variant="outlined"
                            >
                                {t('Moderate')}
                            </AgyleButton>
                            <AgyleButton
                                onClick={
                                    () => {
                                        setAbbeyForm(pr => ({
                                            ...pr,
                                            [`${field}1`]: "3",
                                        }))
                                    }
                                }
                                variant="outlined"
                            >
                                {t('Severe')}
                            </AgyleButton>
                        </Grid>
                        <Grid item xs={1.5}/>
                        <Grid item xs={1}>
                            <AgyleTextField
                                fullWidth
                                name={`${field}1`}
                                value={abbeyForm[`${field}1`]}
                                variant="outlined"
                                type="number"
                            />
                        </Grid>
                    </>
                </Fragment>
            )
        })
    };

    return (
        <div className={classes.container}>
                <Grid container spacing={2}>

                    <Grid container spacing={2}>

                        <Grid item xs={2} className={classes.leftCenter3}>
                            <FormLabel className={classes.leftCenter2}>
                                {t('Abbey Pain Scale\n')}
                            </FormLabel>
                        </Grid>
                        <Grid item xs={1} className={classes.leftCenter3}>
                            <InfoButton> {t("For measurement of pain in those who cannot verbalise\nWhile observing the patient, score questions one to six")} </InfoButton>
                        </Grid>
                        <Grid item xs={3}/>
                        <Grid item xs={6}>
                            <Grid container>
                                <Grid item xs={6} className={classes.leftCenter}>
                                    <FormLabel>{t("Unit No")}</FormLabel>
                                </Grid>
                                <Grid item xs={6} className={classes.margin}>
                                    <AgyleTextField
                                        fullWidth
                                        name="unitNo"
                                        // className={classes.input}
                                        maxRows={25}
                                        debounce
                                        disabled
                                        onChange={handleChangeTextField}
                                        value={abbeyForm.unitNo}
                                        variant="outlined"
                                        // error={!fitnessForWork.patientsName}
                                    />
                                </Grid>

                                <Grid item xs={6} className={classes.leftCenter}>
                                    <FormLabel>{t("Patient's Surname")}</FormLabel>
                                </Grid>
                                <Grid item xs={6} className={classes.margin}>
                                    <AgyleTextField
                                        fullWidth
                                        name="familyName"
                                        // className={classes.input}
                                        maxRows={25}
                                        debounce
                                        disabled
                                        onChange={handleChangeTextField}
                                        value={abbeyForm.familyName}
                                        variant="outlined"
                                        // error={!fitnessForWork.patientsName}
                                    />
                                </Grid>

                                <Grid item xs={6} className={classes.leftCenter}>
                                    <FormLabel>{t("Patient's Name")}</FormLabel>
                                </Grid>
                                <Grid item xs={6} className={classes.margin}>
                                    <AgyleTextField
                                        fullWidth
                                        name="firstName"
                                        // className={classes.input}
                                        maxRows={25}
                                        debounce
                                        disabled
                                        onChange={handleChangeTextField}
                                        value={abbeyForm.firstName}
                                        variant="outlined"
                                        // error={!fitnessForWork.patientsName}
                                    />
                                </Grid>

                                <Grid item xs={6} className={classes.leftCenter}>
                                    <FormLabel>{t("DoB")}</FormLabel>
                                </Grid>
                                <Grid item xs={6} className={classes.margin}>
                                    <AgyleTextField
                                        fullWidth
                                        name="dob"
                                        // className={classes.input}
                                        maxRows={25}
                                        debounce
                                        disabled
                                        onChange={handleChangeTextField}
                                        value={abbeyForm.dob}
                                        variant="outlined"
                                        // error={!fitnessForWork.patientsName}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Divider className={classes.divider}/>

                    <Grid item xs={3}>
                        <div className={classes.label1}>{t('Behaviour scoring')}</div>
                    </Grid>
                    <Grid item xs={1}>
                        <InfoButton>{t('Absent - 0; Mild - 1; Moderate -2; Severe - 3')}</InfoButton>
                    </Grid>
                    <Grid item xs={1.5}/>

                    <Grid item xs={2}>
                        <FormLabel className={classes.tableHeader}> {t('Date and time')} </FormLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <AgyleDatePicker
                            type="date"
                            value={abbeyForm.dateAndTime1}
                            onChange={(param) => {setAbbeyForm((pr) =>
                                ({
                                    ...pr,
                                    dateAndTime1: param
                                }))}}
                        />
                    </Grid>
                    <Grid item xs={1.5}/>
                    <Grid item xs={1}>
                        <FormLabel className={classes.tableHeader}> {t('Score')} </FormLabel>
                    </Grid>

                    <Divider className={classes.divider}/>
                        {renderActivityItems()}
                    <Divider className={classes.divider}/>
                    <Grid item xs={8}/>
                    <Grid item xs={2}>
                        <FormLabel className={classes.tableHeader}> {t('Total score')} </FormLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <AgyleTextField
                            fullWidth
                            name="total1"
                            maxRows={25}
                            debounce
                            disabled
                            onChange={handleChangeTextField}
                            value={abbeyForm.total1}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={8}/>
                    <Grid item xs={2}>
                        <FormLabel className={classes.tableHeader}> {t('Inicials')} </FormLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <AgyleTextField
                            fullWidth
                            name="initials1"
                            maxRows={25}
                            debounce
                            disabled
                            onChange={handleChangeTextField}
                            value={abbeyForm.initials1}
                            variant="outlined"
                        />
                    </Grid>
                    <Divider className={classes.divider}/>

                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <FormLabel>{t("Tick the box which matches the type of pain")}</FormLabel>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl>
                            {/*<InputLabel>{t('Type Of Pain')}</InputLabel>*/}
                            <Select
                                id="typeOfPain"
                                size="small"
                                value={typeOfPainSelect}
                                onChange={handleChangeTypeOfPainSelect}
                                //label={t('typeOfPain')}
                                style={{borderRadius: 10, fontSize: 14, minWidth: 300 }}
                            >
                                <MenuItem value="chronic">{t('Chronic')}</MenuItem>
                                <MenuItem value="acute">{t('Acute')}</MenuItem>
                                <MenuItem value="acuteOnChronic">{t('Acute on chronic')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={5.5}>
                    </Grid>
                    <Grid item xs={6.5}>
                        <InfoButton>
                            {t("Abbey, J; De Bellis, A; Piller, N; Esterman, A; Giles, L; Parker, D and Loway, B.\n")}
                            {t("Funded by the JH & JD Gunn Medical Research Foundation 1998 - 2002\n")}
                            {t("(This document may be reproduced with this acknowledgement retained)")}
                        </InfoButton>
                    </Grid>
                </Grid>
            </div>
        )
}

export default AbbeyPainScaleForm;